import React, { FunctionComponent } from "react";
import { getNumberPostFix } from "../../helpers/stringFormattingMethods";
import "./styles.scss";

export interface IProps {
  date: string;
}

export const AuthorBylineDate: FunctionComponent<IProps> = ({ date: dateStr }) => {
  const date = new Date(dateStr);
  const day = date.toLocaleString("en-UK", { day: "numeric" });
  const month = date.toLocaleString("en-UK", { month: "long" });
  const year = date.toLocaleString("en-UK", { year: "numeric" });
  const dayPostFix = getNumberPostFix(day);

  return (
    <div className="author-byline_date">{`${day}${dayPostFix} ${month} ${year}`}</div>
  );
};
